module.exports = new __parcel__URL__("CommentsIllustration.037c2b17.svg").toString();